import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, map, catchError, throwError } from 'rxjs';
import { Api } from '../contracts/api-paths';
import { ApiResponse, AuthUser, LoginRequest, LoginResponseData, AuthError, MenuItem } from '../models/auth.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService extends Api {
  login(credentials: LoginRequest): Observable<{ token: string; user: AuthUser; menu: MenuItem[] }> {
    return this.http
      .post<ApiResponse<LoginResponseData>>(`${this.apiUrl}/auth/login/admin`, {
        email: credentials.email,
        password: credentials.password,
      })
      .pipe(
        map((response) => {
          if (!response.state) {
            const authError = Object.assign(
              new Error(response.message || 'Error al iniciar sesión'),
              { type: 'invalid_credentials' },
            ) as Error & AuthError;
            throw authError;
          }

          const menu = response.data?.menu ?? [];
          if (typeof window !== 'undefined') {
            localStorage.setItem('menu', JSON.stringify(menu));
          }

          return {
            token: response.data.token.access_token,
            user: response.data.user,
            menu,
          };
        }),
        catchError((error: unknown) => {
          if (error && typeof error === 'object' && !(error instanceof HttpErrorResponse) && 'message' in error) {
            return throwError(() => error as AuthError);
          }
          const authError: AuthError = {
            message: 'Usuario o contraseña incorrectos',
            type: 'invalid_credentials',
          };
          return throwError(() => authError);
        })
      );
  }

  logout(): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(`${this.apiUrl}/auth/logout`, {});
  }

  getProfileByIdentityId(idIdentityUser: number): Observable<ApiResponse<any>> {
    return this.http.get<ApiResponse<any>>(`${this.apiUrl}/profiles/by-identity-id/${idIdentityUser}`);
  }

  getUserIdentityStatus(idUser: number): Observable<ApiResponse<{ idUser: number; idStateFk: number }>> {
    return this.http.get<ApiResponse<{ idUser: number; idStateFk: number }>>(`${this.apiUrl}/user/${idUser}`);
  }
}
